import React from 'react';
import {Input, Loader, Table} from 'semantic-ui-react';
import OnOrdersModal from '../../../part/components/analysis/edit/modals/onOrders';
import DeleteIcon from '../common/icons/DeleteIcon';

const DisplayData = ({item, idx, handleUpdateAmount}) => {
  const {
    partCode,
    name,
    onOrder,
    minStock,
    flagMinStock,
    partQuantity,
    dealersStock,
    availableStock,
    onOrderConfirmed,
  } = item;

  return (
    <Table.Row key={idx} textAlign='center' negative={!name}>
      <Table.Cell>{partCode}</Table.Cell>
      <Table.Cell>{name || 'NÚMERO DE PARTE NO RESGISTRADO'}</Table.Cell>
      <Table.Cell>
        <OnOrdersModal
          code={partCode}
          quantity={onOrder || 0}
          quantityConfirmed={onOrderConfirmed || 0}
        />
      </Table.Cell>
      <Table.Cell>{dealersStock}</Table.Cell>
      <Table.Cell>{availableStock}</Table.Cell>
      <Table.Cell>
        {minStock}
        {flagMinStock > 0 && (
          <p className='error message'>Stock minimo supera stock disponible</p>
        )}
      </Table.Cell>
      <Table.Cell>
        <Input
          type='number'
          min='1'
          max='99999'
          required
          name='partQuantity'
          placeholder='Cant.'
          value={partQuantity}
          id={idx}
          onChange={handleUpdateAmount}
        />
      </Table.Cell>
      <Table.Cell>
        <DeleteIcon index={idx} data={item} dataType='partsOrders' />
      </Table.Cell>
    </Table.Row>
  );
};

const PartsOrdersTable = ({partsOrders, editProviderManualOrderElementQuantity, loadingOrder, loadingPartsArray}) => {
  const handleUpdateAmount = (e, {value, id}) => {
    const quantity = isNaN(value) ? 0 : Number(value);
    editProviderManualOrderElementQuantity(id, quantity);
  };

  const renderTableRecords = () => {
    if (!partsOrders.length) {
      return (
        <Table.Row>
          <Table.Cell textAlign='center' colSpan={13}>
            No hay partes disponibles
          </Table.Cell>
        </Table.Row>
      );
    }

    return partsOrders.map((part, idx) => (
      <DisplayData
        handleUpdateAmount={handleUpdateAmount}
        key={idx}
        item={part}
        idx={idx}
      />
    ));
  };

  if (loadingPartsArray || loadingOrder) {
    return (
      <Table striped className='toyota-grid'>
        <Table.Body>
          <Table.Row>
            <Table.Cell colSpan='100%'>
              <Loader
                active
                inline='centered'
                content={loadingOrder ? 'Ejecutando Orden' : 'Cargando Partes'}
              />
            </Table.Cell>
          </Table.Row>
        </Table.Body>
      </Table>
    );
  }

  return (
    <div className='campaign-container-table'>
      <Table striped>
        <Table.Header>
          <Table.Row textAlign='center'>
            <Table.HeaderCell>NÚMERO PARTE</Table.HeaderCell>
            <Table.HeaderCell>DESCRIPCIÓN</Table.HeaderCell>
            <Table.HeaderCell>ON / ORDER</Table.HeaderCell>
            <Table.HeaderCell>STOCK DEALER</Table.HeaderCell>
            <Table.HeaderCell>STOCK TDE</Table.HeaderCell>
            <Table.HeaderCell>STOCK MÍNIMO</Table.HeaderCell>
            <Table.HeaderCell>CANTIDAD</Table.HeaderCell>
            <Table.HeaderCell>ACCIONES</Table.HeaderCell>
          </Table.Row>
        </Table.Header>
        <Table.Body>
          {renderTableRecords()}
        </Table.Body>
      </Table>
    </div>
  );
};

export default PartsOrdersTable;
